import { CustomSelectFieldProps, SelectField } from 'components/form'
import { TipoEscoamentoSanitarioEnum } from 'graphql/types.generated'

import { tipoEscoamentoSanitarioEnumRecord } from './condicoes-moradia-model'

type TipoEscoamentoSanitarioSelectFieldProps = CustomSelectFieldProps<TipoEscoamentoSanitarioEnum>

export function TipoEscoamentoSanitarioSelectField(props: TipoEscoamentoSanitarioSelectFieldProps) {
  return <SelectField<TipoEscoamentoSanitarioEnum> items={items} itemToString={itemToString} {...props} />
}

const items = Object.values(TipoEscoamentoSanitarioEnum)
const itemToString = (item: TipoEscoamentoSanitarioEnum) => item && tipoEscoamentoSanitarioEnumRecord[item]
